import {
  get,
  post,
  del
} from '@/http/request'
import {
  HOST
} from '@/http/config'

// 获取公文发布列表 (分页)
export function officialDocumentList(params) {
  return get(`${HOST}official-document/list`, params)
}
// 详情 
export function officialDocumentGet(params) {
  return get(`${HOST}official-document/get`, params)
}
// 新增  
export function officialDocumentSave(params) {
  return post(`${HOST}official-document/save`, params)
}
// 删除  
export function officialDocumentDelete(params) {
  return del(`${HOST}official-document/delete`, params)
}
// 修改  
export function officialDocumentUpdate(params) {
  return post(`${HOST}official-document/update`, params)
}
// 公文页头  
export function sysHeaderList(params) {
  return get(`${HOST}sys-header/list`, params)
}
export function getUserIds(params) {
  return get(`${HOST}/official-document/getUserIds`, params)
}
// 通过id获取文件信息
export function createWord(id) {
  return get(`${HOST}official-document/createWord`, { id })
}
// 历史记录
export function getHistoryList(params) {
  return get(`${HOST}officialDocumentHistory/list`, params)
}
//历史记录详情
export function getHistoryVersion(params) {
  return get(`${HOST}officialDocumentHistory/get`, params)
}
// 浏览人
export function getPersonalCounts(params) {
  return get(`${HOST}official-document/getPersonalCounts`, params)
}


// WEBPACK FOOTER //
// ./src/views/OfficialDocument/api/api.js